import { Role, SupervisorRoles } from './roles'

export const PurModifyRoles = [Role.PURCHASE_OFFICER, Role.PURCHASE_SUPERVISOR]

export const PurViewRoles = [
  Role.WAREHOUSE_SUPERVISOR,
  Role.WAREHOUSE_OFFICER,
  Role.QC_SUPERVISOR,
  Role.QC_OFFICER,
  Role.PRODUCTION_SUPERVISOR,
  Role.PRODUCTION_TECHNICIAN,
  Role.PRODUCTION_OFFICER,
  Role.PLANNING_SUPERVISOR,
  Role.PLANNING_OFFICER,
  Role.SALES_SUPERVISOR,
  Role.SALES_OFFICER,
  Role.ACCOUNTING_SUPERVISOR,
  Role.ACCOUNTING_OFFICER,
  ...PurModifyRoles,
  Role.QSS_OFFICER,
]

export const PoProblemViewRoles = [
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.WAREHOUSE_SUPERVISOR,
  Role.QC_SUPERVISOR,
  Role.PRODUCTION_SUPERVISOR,
  Role.PLANNING_SUPERVISOR,
  Role.SALES_SUPERVISOR,
  Role.ACCOUNTING_SUPERVISOR,
  Role.QSS_OFFICER,
]
export const PoProblemModifyRoles = [
  Role.PURCHASE_SUPERVISOR,
  Role.PURCHASE_OFFICER,
  Role.WAREHOUSE_SUPERVISOR,
]

export const Po1010ListRoles = [Role.ADMIN]

export const Po1010ModifyRoles = [Role.ADMIN]

export const PurTrackingRoles = [
  Role.PURCHASE_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.ADMIN,
]

export const PurReportRoles = [
  Role.PURCHASE_OFFICER,
  Role.PURCHASE_SUPERVISOR,
  Role.ADMIN,
  ...SupervisorRoles,
  Role.QSS_OFFICER,
]
